import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { captureSentryException } from '../../monitoring/sentry/sentry-capture.util';
import { LoadingService } from './loading.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private readonly injector: Injector) {}

  private loadingService?: LoadingService;
  handleError(error: any): void {
    this.loadingService ??= this.injector.get(LoadingService);
    this.loadingService.reset();
    console.error(error);
    captureSentryException(error);
  }
}
